import { render, staticRenderFns } from "./JobUpdateDetailForm.vue?vue&type=template&id=dda8e226&"
import script from "./JobUpdateDetailForm.vue?vue&type=script&lang=js&"
export * from "./JobUpdateDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./JobUpdateDetailForm.vue?vue&type=style&index=0&id=dda8e226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports